import React from 'react'
import { Box } from '@usap/uicomponents'
import SetKitDisplay from '../../../../SetKitDisplay'
import { disableStyle } from '../constant'

const ParentSku = props => {
  const {
    selectedPart,
    displayNull,
    eligibleRMA,
    parentSku,
    showTabs,
    isDesktop,
    isWmoEnabled = false,
    multipleItemsPresent
  } = { ...props }
  return (
    <>
      { showTabs && selectedPart && parentSku && (
        isWmoEnabled ?
        <Box
          style={{ width: "100%" }}
          margin={{ top: "16px" }}
        >
          <SetKitDisplay
            parentSku={parentSku}
            showPartNumber={false}
            isWmoEnabled
          />
       </Box>
        : 
        <Box pad={{ horizontal: '16px', top: '16px' }}>
          <SetKitDisplay
            parentSku={parentSku}
            showPartNumber={false}
          />
        </Box>
      )}
      {!isDesktop && !showTabs && !selectedPart && parentSku && (
        <Box
          pad={isWmoEnabled && multipleItemsPresent ? {} : { horizontal: '16px', top: '16px' }}
          style={eligibleRMA || !displayNull ? null : disableStyle}
        >
          <SetKitDisplay
            parentSku={parentSku}
            showPartNumber={false}
            isWmoEnabled={isWmoEnabled}
          />
        </Box>
      )}
    </>
  )
}

export default ParentSku
